import { useState } from "react";
import { Link } from "react-router-dom";
import Shell from "../components/Shell";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) { setError(formatApiError(err)); }
        setLoading(false);
    };

    return (
        <Shell variant="public">
            <div className="max-w-md mx-auto px-6 py-20 animate-fade-in">
                <p className="eyebrow mb-3">Password reset</p>
                <h1 className="font-heading text-3xl font-light mb-3">Reset your password</h1>
                <p className="text-zinc-600 mb-10 text-sm">Enter your email and we will send you a secure reset link.</p>
                {sent ? (
                    <div data-testid="forgot-sent" className="text-sm text-zinc-700 bg-zinc-50 border border-zinc-200 px-4 py-4 rounded-sm">
                        If an account exists for <strong>{email}</strong>, a reset link has been sent.
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form">
                        <div>
                            <label className="input-label">Email</label>
                            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base" />
                        </div>
                        {error && <div className="text-sm text-red-700">{error}</div>}
                        <button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-primary w-full">{loading ? "Sending…" : "Send reset link"}</button>
                    </form>
                )}
                <div className="mt-8 text-sm"><Link to="/login" className="text-zinc-500 hover:text-black">← Back to sign in</Link></div>
            </div>
        </Shell>
    );
}
